import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import { formatDate } from '@atheneum/api/dist/lib'

import Button from '@components/Button'
import Star from '@components/Icon/Star'

class ExpertFeedback extends Component {
  static propTypes = {
    feedbacks: PropTypes.object,
    modalStore: PropTypes.object
  }

  render () {
    const { feedbacks, modalStore } = this.props
    return (
      <div className='expert-form'>
        <h1 className='expert-form__title'>
          Feedback for consultation on {formatDate(feedbacks.created_at)}
        </h1>
        <div className='expert-form__section'>
          <h2 className='expert-form__subtitle--with-action m-t-0 m-b-xxl'>
            Consultation quality
            <div className='expert-form__subtitle--with-action'>
              <Star fill='icon__fill--gold' />
              {feedbacks.rating1 ? feedbacks.rating1.toFixed(2) : 'N/A'}
            </div>
          </h2>
          <div className='expert-form__input-group'>
            <label className='expert-form__label expert-form__label--reset-line-height'>
              Question
            </label>
            <div className='expert-form__input-wrapper expert-form__input-wrapper--wide'>
              <b>
                How would you rate the interaction between you and the client?
                (10 being the highest, 1 being the lowest)
              </b>
            </div>
          </div>
          <div className='expert-form__input-group'>
            <label className='expert-form__label expert-form__label--reset-line-height'>
              Comment
            </label>
            <div className='expert-form__input-wrapper expert-form__input-wrapper--wide'>
              {feedbacks.comment1 || 'N/A'}
            </div>
          </div>
        </div>
        <div className='expert-form__section'>
          <h2 className='expert-form__subtitle--with-action m-t-0 m-b-xxl'>
            Atheneum coordination
            <div className='expert-form__subtitle--with-action'>
              <Star fill='icon__fill--gold' />
              {feedbacks.rating2 ? feedbacks.rating2.toFixed(2) : 'N/A'}
            </div>
          </h2>
          <div className='expert-form__input-group'>
            <label className='expert-form__label expert-form__label--reset-line-height'>
              Question
            </label>
            <div className='expert-form__input-wrapper expert-form__input-wrapper--wide'>
              <b>
                How would you rate the interaction between you and Atheneum
                professionals? (10 being the highest, 1 being the lowest)
              </b>
            </div>
          </div>
          <div className='expert-form__input-group'>
            <label className='expert-form__label expert-form__label--reset-line-height'>
              Comment
            </label>
            <div className='expert-form__input-wrapper expert-form__input-wrapper--wide'>
              {feedbacks.comment2 || 'N/A'}
            </div>
          </div>
        </div>
        <div className='expert-form__section'>
          <h2 className='expert-form__subtitle--with-action m-t-0 m-b-xxl'>
            Overall experience
            <div className='expert-form__subtitle--with-action'>
              <Star fill='icon__fill--gold' />
              {feedbacks.rating3 ? feedbacks.rating3.toFixed(2) : 'N/A'}
            </div>
          </h2>
          <div className='expert-form__input-group'>
            <label className='expert-form__label expert-form__label--reset-line-height'>
              Question
            </label>
            <div className='expert-form__input-wrapper expert-form__input-wrapper--wide'>
              <b>
                How likely are you to recommend our network to others within
                and/or outside of your peer group? (10 being Extremely likely, 1
                Not at all likely)
              </b>
            </div>
          </div>
          <div className='expert-form__input-group'>
            <label className='expert-form__label expert-form__label--reset-line-height'>
              Comment
            </label>
            <div className='expert-form__input-wrapper expert-form__input-wrapper--wide'>
              {feedbacks.comment3 || 'N/A'}
            </div>
          </div>
        </div>
        <div className='expert-form__section'>
          <Button
            className='position-absolute'
            secondary
            onClick={modalStore.close}
          >
            Close
          </Button>
        </div>
      </div>
    )
  }
}

ExpertFeedback.defaultProps = {
  feedbacks: {},
  hideButtons: true
}

export default inject('modalStore')(observer(ExpertFeedback))
